import { combineReducers } from 'redux';
import types from './types';
import ArSummaryModel from 'src/model/arSummary.model';
import INITIAL_STATE, { IInitialState } from 'src/store/initialState';

const getArSummaryIsPending = (
  state: boolean = false,
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.GET_AR_SUMMARY_IS_PENDING:
      return payload;

    default:
      return state;
  }
};

const content = (
  state: IInitialState['arSummary'] = INITIAL_STATE.arSummary,
  { type, payload }: { type: string; payload: ArSummaryModel }
) => {
  switch (type) {
    case types.CLEAR_ALL:
      return INITIAL_STATE.arSummary;
    case types.SET_CONTENT:
      return payload;

    default:
      return state;
  }
};

const error = (
  state: { caller: string; error: any } = { caller: '', error: null },
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.AR_SUMMARY_ERROR:
      return payload;

    default:
      return state;
  }
};

export default combineReducers({
  content,
  getArSummaryIsPending,
  error
});
